import React from 'react';
import PropTypes from 'prop-types';
import CurrencyIcon from 'components/CurrencyIcon';
import './PointValueContainer.css';

function PointValueContainer({ className, icon, iconAlt, children, onClick }) {
  const setClass = 'point-value-container' + (className ? ' ' + className : '');
  return (
    <button type="button" className={setClass} onClick={onClick}>
      {!!icon && (
        <CurrencyIcon className="point-value-container-icon" type={icon} />
      )}
      {children}
    </button>
  );
}

PointValueContainer.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node
};

export default PointValueContainer;
